// @ts-nocheck
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import Focusable from 'components/focus/Focusable';
import { useFocusManager } from 'hooks/focus';
import useTimeout from 'hooks/timeout';
import applicationActions from 'common/support/applicationActions';

import TextToSpeechManager from 'support/tts/TextToSpeechManager';
import styles from './Error.module.scss';
import LogoPage from './LogoPage';

const ERROR_IDLE_TIMEOUT_MS = 5 * 60 * 1000;

const Error = ({ onDismiss, message }) => {
  const focusManager = useFocusManager();
  const history = useHistory();

  useEffect(() => {
    focusManager.setCurrentFocus('error-page');
  }, [focusManager]);

  const dismiss = () => {
    if (onDismiss) onDismiss();
    else history.goBack();
  };

  useTimeout(() => {
    dismiss();
  }, ERROR_IDLE_TIMEOUT_MS);

  const onAction = action => {
    switch (action) {
      case applicationActions.back:
        dismiss();
        return true;
      default:
        return false;
    }
  };

  // Since message isn't necessarily a string, we'll want to
  // compare the actual text content to see if it's changed
  // to decide whether to read out tts
  const prevText = useRef();
  const messageRef = useRef();
  useEffect(() => {
    if (messageRef.current?.innerText !== prevText.current) {
      TextToSpeechManager.add(messageRef.current.innerText);
      TextToSpeechManager.speak();
    }

    prevText.current = messageRef.current?.innerText;
  }, [message]);

  return (
    <React.Fragment>
      <LogoPage background="opaque" className="position-fixed" />
      <Focusable
        focusId="error-page"
        className={classNames(
          'w-100',
          'h-100',
          'd-flex',
          'justify-content-center',
          'align-items-center',
          'fixed-top',
          'text-center',
        )}
        onAction={onAction}
        render={() => {
          return (
            <React.Fragment>
              <div className={styles.message} ref={messageRef}>
                {message}
              </div>
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

Error.propTypes = {
  onDismiss: PropTypes.func,
  message: PropTypes.node,
};

Error.defaultProps = {
  onDismiss: null,
  message: null,
};

export default Error;
